






import { Component, Vue, Prop } from 'vue-property-decorator'
import RatioBar from '@/components/common/atoms/RatioBar.vue'

@Component({
  components: { RatioBar },
})
export default class ByProblemTagRatio extends Vue {
  @Prop()
  totalScore!: number
  @Prop()
  localScore!: number
  @Prop({ default: 100 })
  perfectScoreNumber!: number

  /**
   * 点数のパーセンテージを計算する（点数 / 満点 * 100）
   */
  private getRatio(scoreNumber: number | null): number {
    if (!scoreNumber) return 0
    return (scoreNumber / this.perfectScoreNumber) * 100
  }
}
